"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var utils_1 = require("../../core/utils");

var ReleaseType_1 = require("../../release/model/ReleaseType");

var SelloutReleaseType_1 = require("../../release/model/sellout/SelloutReleaseType");

var PriceListSettings_1 = require("../model/PriceListSettings");

var PriceCodeSettingsConverter_1 = require("./PriceCodeSettingsConverter");

var PriceListSettingsConverter_1 = require("./PriceListSettingsConverter");
/**
 * Implementation of {@link PriceListSettingsConverter}
 *
 * @author Radek Beran
 */


var PriceListSettingsConverterImpl =
/*#__PURE__*/
function (_PriceListSettingsCon) {
  _inherits(PriceListSettingsConverterImpl, _PriceListSettingsCon);

  function PriceListSettingsConverterImpl(priceCodeSettingsConverter) {
    var _this;

    _classCallCheck(this, PriceListSettingsConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PriceListSettingsConverterImpl).call(this));
    _this.priceCodeSettingsConverter = priceCodeSettingsConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(PriceListSettingsConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      var classId = conversions.documentToClassId(source);

      if (utils_1.Utils.isValueMissing(source.priceListTypeId)) {
        throw new Error("priceListTypeId is missing for PriceListSettings with id=".concat(classId));
      }

      return new PriceListSettings_1.PriceListSettings(classId, conversions.asEnumOpt(source.releaseType, ReleaseType_1.ReleaseType), source.priceListType, conversions.toClassReferenceId(source.priceListTypeId), conversions.asObjectList(source, 'priceCodes', function (doc) {
        return _this2.priceCodeSettingsConverter.toObject(doc, conversions);
      }).sort(function (a, b) {
        return a.rulePriority - b.rulePriority;
      }), source.priority, conversions.asObjectList(source, 'tags', function (v) {
        return v;
      }), conversions.asEnumOpt(source.selloutReleaseType, SelloutReleaseType_1.SelloutReleaseType));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this3 = this;

      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        releaseType: source.releaseType !== null ? source.releaseType.toString() : null,
        priceListType: source.priceListType,
        priceListTypeId: conversions.toDocumentReferenceId(source.priceListTypeId),
        priceCodes: conversions.asObjectArray(source, 'priceCodes', function (settings) {
          return _this3.priceCodeSettingsConverter.toDocument(settings, conversions);
        }),
        priority: source.priority,
        tags: conversions.asObjectArray(source, 'tags', function (v) {
          return v;
        }),
        selloutReleaseType: source.selloutReleaseType !== null ? source.selloutReleaseType.toString() : null
      });
      return result;
    }
  }]);

  return PriceListSettingsConverterImpl;
}(PriceListSettingsConverter_1.PriceListSettingsConverter);

PriceListSettingsConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [PriceCodeSettingsConverter_1.PriceCodeSettingsConverter])], PriceListSettingsConverterImpl);
exports.PriceListSettingsConverterImpl = PriceListSettingsConverterImpl;